var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation Bar / x / Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exit_to_app",
    d: "M28.4766 4.5C29.2734 4.5 29.9766 4.80469 30.5859 5.41406C31.1953 6.02344 31.5 6.72656 31.5 7.52344V28.4766C31.5 29.2734 31.1953 29.9766 30.5859 30.5859C29.9766 31.1953 29.2734 31.5 28.4766 31.5H7.52344C6.67969 31.5 5.95312 31.1953 5.34375 30.5859C4.78125 29.9766 4.5 29.2734 4.5 28.4766V22.5H7.52344V28.4766H28.4766V7.52344H7.52344V13.5H4.5V7.52344C4.5 6.72656 4.78125 6.02344 5.34375 5.41406C5.95312 4.80469 6.67969 4.5 7.52344 4.5H28.4766ZM15.1172 23.4141L18.9844 19.4766H4.5V16.5234H18.9844L15.1172 12.5859L17.2266 10.4766L24.75 18L17.2266 25.5234L15.1172 23.4141Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.609878532f14f642dda3820bf46aa027.svg";
export { ForwardRef as ReactComponent };